import { parseAsString, useQueryStates } from 'nuqs';
import { parseAsStationAccessFilter } from './parse-as-station-access-filter';
import { parseAsStationTypeFilter } from './parse-as-station-type-filter';
import { parseAsStatusActivityFilter } from './parse-as-status-activity-filter';

/**
 * Hook that syncs status screen filters (text, status, type, access) with URL query params.
 * Uses nuqs for type-safe serialization. URL is the source of truth.
 */
export function useStatusQueryFilter() {
  const [queryParams, setQueryParams] = useQueryStates(
    {
      text: parseAsString.withDefault(''),
      // Optional: when absent or null = show online and offline (both toggles selected in UI).
      status: parseAsStatusActivityFilter,
      // Optional: when absent or null = show all. Comma-separated when multiple types are selected.
      type: parseAsStationTypeFilter,
      access: parseAsStationAccessFilter,
    },
    {
      history: 'replace',
    },
  );

  return {
    queryParams,
    setQueryParams,
  };
}
